<template>
    <li class="has-sub" @click="hideSidebar">
        <router-link :to="`/${course.route}`" :title="course.name">
            <img class="aside-menu__icon" :src="course.icon | imgSrc" alt="" width="22px">
            <span class="title">{{ course.name }}</span>
            <div
                v-if="course.toSign"
                class="navigation-notice"
            >
                {{ course.toSign }}
            </div>
        </router-link>
    </li>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        props: ['course'],
        components: {
            //
        },
        computed: {

        },
        methods: {
            ...mapActions(['toggleSidebarLeft']),
            hideSidebar() {
                const ww = window.innerWidth;

                if (ww < 768) this.toggleSidebarLeft(false);
            }
        },
    }
</script>

<style lang="sass" scoped>
.navigation-notice
    margin-left: auto
</style>
